import { AirportMarketFilter } from './airports';
import { AirportType } from '../_commons/locations';

export function prepareAirportForMarket(airport = {}, airportType, filterByMarket = 'NONE') {
  let { filterFields } = airport;
  if (!filterFields && filterByMarket !== AirportMarketFilter.NONE) {
    console.error('** NO_FILTER_FIELDS_ADDED_IN_CONFIGURATION**');
  }

  let resultAirPort = { ...airport };

  switch (filterByMarket.toUpperCase()) {
    case AirportMarketFilter.NONE:
      delete resultAirPort.filterFields;
      break;
    case AirportMarketFilter.ALL:
      break;
    case AirportMarketFilter.ORIGIN:
      if (airportType !== AirportType.ORIGIN) {
        delete resultAirPort.filterFields;
      }
      break;
    case AirportMarketFilter.DESTINATION:
      if (airportType !== AirportType.DESTINATION) {
        delete resultAirPort.filterFields;
      }
      break;
    default:
  }

  if (resultAirPort.filterDestination) {
    if (airportType !== AirportType.DESTINATION) {
      delete resultAirPort.filterDestination;
    } else {
      resultAirPort = { ...resultAirPort, filterFields: resultAirPort.filterDestination };
      delete resultAirPort.filterDestination;
    }
  }

  return resultAirPort;
}
